import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

const Header = lazy(() => import('./components/Header/Header.js'));
const Home = lazy(() => import('./components/Home/Home.js'));
const About = lazy(() => import('./components/About/About.js'));
const Resume = lazy(() => import('./components/Resume/Resume.js'));
const Orangetheory = lazy(() => import('./components/Orangetheory/Orangetheory.js'));
const OrangetheoryWorkoutTracker = lazy(() => import('./components/Orangetheory/OrangetheoryWorkoutTracker.js'));
const Projects = lazy(() => import('./components/Projects/Projects.js'));
const ParksChecklist = lazy(() => import('./components/Parks/ParksChecklist.js'));
const RentVsBuy = lazy(() => import('./components/SchoolProjects/RentVsBuy.js'));
const CosemeticsFutureCasting = lazy(() => import('./components/SchoolProjects/CosemeticsFutureCasting.js'));
const TXStateParks = lazy(() => import('./components/Parks/TXStateParks.js'));
const NationalParks = lazy(() => import('./components/Parks/NationalParks.js'));

function App() {
  return (
    <Router>
      <Suspense fallback={<div style={{ padding: '2rem', textAlign: 'center' }}>Loading...</div>}>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/resume" element={<Resume />} />
          <Route path="/otf" element={<Orangetheory />} />
          <Route path="/otf-workout-tracker" element={<OrangetheoryWorkoutTracker />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/parks-checklist" element={<ParksChecklist />} />
          <Route path="/rent-vs-buy" element={<RentVsBuy />} />
          <Route path="/rougir-production-strategy" element={<CosemeticsFutureCasting />} />
          <Route path="/texas-state-parks" element={<TXStateParks />} />
          <Route path="/national-parks" element={<NationalParks />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;